import React from 'react';
import Table from '../../components/common/Table';
import {AuditLogDTO} from "../../services/apiClient";
import {truncateString} from "../../utils/stringUtils";

interface CompanyInfoTableProps {
    data: any[];
    currentPage: number;
    totalPages: number;
    setCurrentPage: (page: number) => void;
    pageSize: number;
    setPageSize: (size: number) => void;
    isLoading: boolean;
}

const CompanyInfoTable: React.FC<CompanyInfoTableProps> = ({
                                                               data,
                                                               currentPage,
                                                               totalPages,
                                                               setCurrentPage,
                                                               pageSize,
                                                               setPageSize,
                                                               isLoading,
                                                           }) => {
    return (
        <Table
            columns={[
                {
                    label: 'Action',
                    key: 'action',
                    render: (row: AuditLogDTO) => (
                        <span
                            className={`inline-block px-2 py-1 text-xs font-bold rounded ${
                                row.action === 'Create'
                                    ? 'bg-green-100 text-green-700'
                                    : 'bg-yellow-100 text-yellow-700'
                            }`}
                        >
                    {row.action}
                </span>
                    ),
                },
                { label: 'Property', key: 'propertyName' },
                {
                    label: 'Old Value',
                    key: 'oldValue',
                    render: (row: AuditLogDTO) => (
                        <span className="line-through text-red-500">{truncateString(row.oldValue ?? '', 50) }</span>
                    ),
                },
                {
                    label: 'New Value',
                    key: 'newValue',
                    render: (row: AuditLogDTO) => (
                        <span className="inline-block px-2 py-1 bg-green-100 text-green-700 rounded font-bold">
              {truncateString(row.newValue ?? '', 50)}
            </span>
                    ),
                },
            ]}
            data={data}
            groupBy={['createdUtc', 'tableName', 'recordId']}
            groupHeaderRender={(group, rows) => {
                const [date, tableName, recordId] = group.split(' - ');

                return (
                    <>
                        <div className="flex items-center space-x-2">
                            <span className="text-sm text-gray-800 dark:text-gray-200">
                                {date} - {tableName}
                            </span>
                            <span className="inline-block px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded">
                                Record ID: {recordId}
                            </span>
                        </div>
                        <span className="ml-auto text-sm text-gray-500 hidden sm:block">
                          {rows.length} records
                        </span>
                    </>
                );
            }}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            pageSize={pageSize}
            onPageSizeChange={setPageSize}
            isLoading={isLoading}
        />
    );
};

export default CompanyInfoTable;

